import ApplicationController from './application_controller'

/**
 * OBJECTIVE: Unfold a trigger button into the block it controls (a form, a
 * confirmation step) and fold it back. While the block shows, the trigger
 * hides, so the action reads as one control that expands into its next step.
 *
 * EXAMPLE:
 * <div data-controller="disclosure">
 *   <button data-disclosure-target="trigger" data-action="disclosure#open">Close incident</button>
 *   <div class="hidden" data-disclosure-target="content">
 *     <textarea data-disclosure-target="focus"></textarea>
 *     <button type="button" data-action="disclosure#close">Cancel</button>
 *   </div>
 * </div>
 *
 * Server-rendered open state (e.g. a validation error): render the content
 * without `hidden`; connect() hides the trigger to match.
 */
export default class extends ApplicationController {
  static targets = ['trigger', 'content', 'focus']

  connect () {
    this.sync(!this.contentTarget.classList.contains('hidden'))
  }

  open () {
    this.sync(true)
    if (this.hasFocusTarget) this.focusTarget.focus()
  }

  close () {
    this.sync(false)
    this.triggerTarget.focus()
  }

  sync (open) {
    this.contentTarget.classList.toggle('hidden', !open)
    this.triggerTarget.classList.toggle('hidden', open)
    this.triggerTarget.setAttribute('aria-expanded', String(open))
  }
}
